import { Variants } from "motion/react";

export const reportAnimationVariants: Variants = {
  initial: {
    height: 0,
    opacity: 0,
    transition: {
      bounce: 0,
      duration: 0.7,
      delayChildren: 0.3,
      staggerChildren: 0.05,
    },
  },
  animate: {
    height: 36,
    opacity: 1,
    transition: {
      type: "spring",
      bounce: 0,
      duration: 0.7,
      delayChildren: 0.3,
      staggerChildren: 0.05,
    },
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: {
      type: "spring",
      bounce: 0,
      duration: 0.7,
      delayChildren: 0.1,
      staggerChildren: 0.05,
    },
  },
};
